import throwError from "../throwError";
var getBoldTypographyName = function getBoldTypographyName(theme, typography) {
  var boldTypography = theme.typography[typography].boldTypography;
  if (!boldTypography) {
    return throwError("Typography \"".concat(typography, "\" doesn't have defined equivalent of it's bold version!"));
  }
  return boldTypography;
};
export default getBoldTypographyName;